var map = {
	"./assets/animations/click.json": 5615,
	"./assets/animations/generate_drawing.json": 1201,
	"./assets/animations/hi.json": 2818,
	"./assets/animations/locked.json": 539,
	"./assets/animations/love.json": 6696,
	"./assets/animations/move.json": 2587,
	"./assets/animations/sent.json": 585,
	"./assets/animations/zoom.json": 1011,
	"./locales/de.json": 9929
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5969;